import { useState } from "react";
import { _BudgetID, _single } from "../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../core/services/dataBean/useDataBean"
import { YearSelector } from "../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../RemoteAbstractAction/editors/MonthConstantsEditor";
import { BasicPage } from "../theme/Component/BasicPage"
import { BasicButton } from "../theme/Component/BasicButton";
import { PrintJson } from "../theme/Component/PrintJson";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable";
import { DropDown } from "../theme/Component/DropDown";
import useModal, { MODAL_XL } from "../theme/Component/hooks/useModal";
import { Modal } from "../theme/Component/Modal";
import AutoChart from "../../core/graph/AutoChart";
import { AccountEditor } from "../editor/AccountEditor";

export const BudgetEgressReport = () => {

    const _budget = useDataBean(_BudgetID);
    const { lista, setLista, bean, setBean } = _budget;
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [month, setMonth] = useState<number>(_single.getCurrentMonth());
    const modalGraph = useModal("Grafica", MODAL_XL);
    const [filter,setFilter] = useState<any>({});


    const getEgresoReport = () => {

        _budget.instance.getEgresoReport(1, 10000,_single.cleanMap(filter), year, month).then(
            (resp: any) => {
                if(resp.List)
                {
                    resp.List.forEach(element => {
                        element.DataBeanProperties.DocumentoCausacion = 
                        (element.DataBeanProperties.DocumentMnemonic ?? '') +"-"+(element.DataBeanProperties.DocumentConsecutive ?? '');
                        element.DataBeanProperties.DocumentoEgreso = 
                        (element.DataBeanProperties.CEMnemonic ?? '') +"-"+(element.DataBeanProperties.CEConsecutive ?? '');
                        element.DataBeanProperties.DocumentoObligacion = 
                        (element.DataBeanProperties.OBMnemonic ?? '') +"-"+(element.DataBeanProperties.OBConsecutive ?? '');
                        element.DataBeanProperties.CEValue = parseFloat(element.DataBeanProperties.CEValue ?? 0);
                        
                    });
                }
                setLista(resp.List);
            }
        )
    }

        const head = [
        // {title:'ID',property:'IDPaymentAccountItem',visible:false,mask:MASK_NUMBER},
        // {title:'Concepto',property:'Concepto',visible:true},
        // {title:'Rubro',property:'BudgetID',visible:true},        
        // {title:'Nombre Rubro',property:'BudgetName',visible:true},        
        {title:'Nit',property:'Nit',visible:true,mask:MASK_NUMBER},        
        {title:'Tercero',property:'EntityAccount',visible:true},        
        {title:'Descripciòn',property:'Description',visible:true},        
        {title:'Afectación',property:'DocumentoObligacion',visible:true},        
        {title:'Causación',property:'DocumentoCausacion',visible:true},        
        {title:'Egreso',property:'DocumentoEgreso',visible:true},                
        {title:'Fecha',property:'CEDate',visible:true,mask:MASK_DATE},        
        {title:'Valor',property:'CEValue',visible:true,mask:MASK_MONEY},        
        // {title:'Cuenta Giro',property:'AccountNumber',visible:true},        
        // {title:'Banco Giro',property:'BankName',visible:true},        
    ]
     const actionsDropDown = [
                    { id: 1, name: 'Reporte Gráfico', permiso: null, activo: true },
                ];
                const buttons = () => {
                    return (
                        <div className="row">
                            <div className="col-md-12">
                                <DropDown lista={actionsDropDown} eventClick={(e) => {
                                    if (e.id == 1) {
                                        modalGraph.open();
                                    }
                                }}></DropDown>
                            </div>
                        </div>
                    )
                }

    return (
        <BasicPage titulo="Reporte Egreso">
            <div className="row">
                <div className="col-md-2">
                    <YearSelector tittle="Año" onChange={(e) => { setYear(parseInt(e)) }} value={year} />
                </div>
                <div className="col-md-2">
                    <MonthConstantsEditor name="" idSelect={month} onChange={(e) => { setMonth(parseInt(e)) }} label="Mes" />
                </div>
                <div className="col-md-3">
                    <AccountEditor label="Tercero" idAccount={filter.IDAccount} onChange={(e)=>{setFilter({...filter,"IDAccount":e.IDAccount})}}/>
                </div>
                <div className="col-md-2">
                    <BasicButton icon="" useMargin eventClick={getEgresoReport}>Buscar</BasicButton>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <BasicTable 
                    // headButtons={buttons()} 
                    head={head} body={lista} rowSet={setBean}></BasicTable>
                     <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={head} useIndexAsXLabel={true}
                            xOptions={['Concepto', 'EntityAccount','DocumentoObligacion','DocumentoCausacion','DocumentoEgreso']}
                            yOptions={['CEValue']} />

                    </Modal>
                    {/* <PrintJson json={lista} /> */}
                </div>
            </div>
        </BasicPage>
    )
}